import { render, staticRenderFns } from "./ClockBlock.vue?vue&type=template&id=12001e57&scoped=true&"
import script from "./ClockBlock.vue?vue&type=script&lang=js&"
export * from "./ClockBlock.vue?vue&type=script&lang=js&"
import style0 from "./ClockBlock.vue?vue&type=style&index=0&id=12001e57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12001e57",
  null
  
)

export default component.exports